<template>
  <div>
    <slot :openDialog="openDialog"></slot>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  data() {
    return {
      overlayName: '#products-confirm',
    }
  },
  methods: {
    ...mapActions('overlay', {
      passProps: 'passProps',
      setOverlay: 'openOverlay',
    }),
    openDialog(uuid) {
      this.passProps({ uuid })
      this.setOverlay(this.overlayName)
    },
  },
}
</script>
